const rx = /^(?<hh>\d\d):(?<mm>\d\d)((?<ss>\d\d)(\.(?<ff>\d+))?)?$/;

const int = (str: undefined | string) => (str ? Number(str) : 0);

/**
 * Converts time string (HH:MM:SS.FFF) into number of milliseconds since the start of the day
 */
const timeStringToNumber = (time: string): number => {
	const match = rx.exec(time);

	if (!match || !match.groups) {
		throw new Error(`Invalid time format (${time})`);
	}

	const { hh, mm, ss, ff } = match.groups;

	return int(hh) * 60 * 60 * 1000 + int(mm) * 60 * 1000 + int(ss) * 1000 + int(ff);
};

export default timeStringToNumber;
